import React from 'react';
import {Link,NavLink} from 'react-router-dom';

const About=()=>{
return(
<div>
	<nav className="ui raised very padded segment">
		<span style={{fontSize:'25px'}} ><Link to="/">Asfak Ahmed</Link></span>
		<div className="ui right floated header">
			<Link to="/About"><button className="ui yellow button">About</button></Link>
			<NavLink to="/Projects"><button className="ui button">Projects</button></NavLink>
			<NavLink to="/Contact"><button className="ui button">Contact</button></NavLink>
		</div>
	</nav>

	<div className="ui raised very padded text container segment" style={{marginTop:'80px'}}>
		<h3 className='ui header'>Some details about me.</h3>
		<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus, natus!
			Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eos, ipsum quo rerum atque veniam quod.
			Lorem ipsum dolor sit amet, consectetur adipisicing elitipsum quo rerum
			ipsum quo rerum	Lorem ipsum dolor sit amet, consectetur adipisicing elit.
			Molestias ducimus atque repellendus enim iusto sint inventore ipsum ratione
			delectus.
		</p>
	</div>
</div>

)
}
export default About;